import { SB } from '@play-co/replicant';
import {
  createScheduledActions,
  extractScheduledActionHandlers,
} from '../../createScheduledActions';
import {
  scheduleBotNotification,
  sendBotNotification,
} from './chatbot.modifiers';

const schema = {
  sendBotNotification: SB.unknown(),
  sendFriendJoinedMessage: SB.object({
    chatId: SB.number(),
    friendName: SB.string(),
    bonus: SB.int(),
  }),
};

const actions = createScheduledActions(schema)({
  sendBotNotification: (state, _, api) => sendBotNotification(state, api),
  sendFriendJoinedMessage: (state, { friendName, bonus }, api) => {
    if (state.notificationBacklog.friendJoined) {
      const previousFriendCount =
        state.notificationBacklog.friendJoined.friendCount ??
        state.notificationBacklog.friendJoined.payload.length;
      state.notificationBacklog.friendJoined.friendCount =
        previousFriendCount + 1;
    } else {
      state.notificationBacklog.friendJoined = {
        triggerTime: api.date.now(),
        payload: [
          {
            friendName: friendName,
            bonus: bonus,
          },
        ],
        friendCount: 1,
      };
    }

    scheduleBotNotification(state, api);
  },
});

export const chatbotScheduledActions = {
  schema,
  actions: extractScheduledActionHandlers(actions),
};
